// extracted by mini-css-extract-plugin
module.exports = {"tagCloud":"TagCloud_tagCloud__3EB9D","error":"TagCloud_error__1j1r-","errorH1":"TagCloud_errorH1__3jFDf","tag":"TagCloud_tag__1ruqq","tagLink":"TagCloud_tagLink__26RZl"};